import React, { FC } from 'react';
import { KeyRound } from 'lucide-react';
import { Button } from 'antd';
import cx from 'classnames';
import styles from './index.module.css';
import { McpInstallGuideButton } from './mcpInstallGuideButton';

type Props = {
  mobileView?: boolean;
  articleId: number;
  clientName: string;
  enabled: boolean;
  buttonDisabled: boolean;
};

export const McpIntegrationActions: FC<Props> = ({
  mobileView,
  articleId,
  clientName,
  enabled,
  buttonDisabled
}) => {
  return (
    <div
      className={cx(styles.integrationActions, {
        [styles.mobileActionsView]: mobileView
      })}
    >
      <McpInstallGuideButton
        articleId={articleId}
        clientName={clientName}
        buttonProps={{
          className: styles.guideButton,
          disabled: buttonDisabled
        }}
      />
      {enabled && (
        <Button
          type="default"
          className={styles.guideButton}
          disabled={buttonDisabled}
          icon={<KeyRound className={styles.connectedButtonIcon} />}
          onClick={() => {
            window.location.pathname = '/settings/mcp-access-tokens';
          }}
        >
          Revoke Access
        </Button>
      )}
    </div>
  );
};
